import React, { createContext, useContext } from 'react';

type ChurchPlannerRailContextValue = {
  dashboardServiceId?: string;
  setDashboardServiceId: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const ChurchPlannerRailContext = createContext<ChurchPlannerRailContextValue | null>(null);

export function ChurchPlannerRailProvider({
  value,
  children,
}: {
  value: ChurchPlannerRailContextValue;
  children: React.ReactNode;
}) {
  return <ChurchPlannerRailContext.Provider value={value}>{children}</ChurchPlannerRailContext.Provider>;
}

export function useChurchPlannerRail() {
  const context = useContext(ChurchPlannerRailContext);
  if (!context) {
    throw new Error('useChurchPlannerRail must be used within a ChurchPlannerRailProvider');
  }
  return context;
}